/**
 * useArrayRef
 * -----------
 * A custom hook that returns a mutable ref containing an array of DOM elements.
 * Useful when you need to manage multiple refs dynamically, such as in a loop.
 *
 * Usage:
 * const buttonRefs = useArrayRef<HTMLButtonElement>();
 * const setButtonRef = setRefAtIndex(buttonRefs, index);
 *
 * <button ref={setButtonRef} />
 *
 * Note:
 * Avoid using inline functions like `el => buttonRefs.current[index] = el`
 * as it recreates a new function on each render, potentially causing
 * unnecessary DOM reattachments or bugs. Use `setRefAtIndex` instead.
 *
 * Returns:
 * - MutableRefObject<(T | null)[]> — a stable ref holding an array of elements.
 */

import { RefObject, useRef } from 'react';

export function useArrayRef<T>(): RefObject<(T | null)[]> {
  return useRef<(T | null)[]>([]);
}
